/**
 * Barista Station Page
 * KDS display for barista to prepare coffee drinks
 * Uses shared KDSStationLayout with auto-reconnect and offline caching
 */
import { Coffee } from 'lucide-react';
import KDSStationLayout from '@/components/kds/KDSStationLayout';

export default function BaristaStationPage() {
  return (
    <KDSStationLayout
      station="barista"
      stationName="Barista Station"
      stationIcon={Coffee}
      iconColorClass="bg-gradient-to-br from-blue-500 to-blue-600"
      defaultDeviceId="KDS-BAR-01"
    />
  );
}
